module.exports = __webpack_public_path__ + "img/bumble_02.562707dc.png";